import styled from 'styled-components';

export const PageContainer = styled.div`
	min-height: calc(100dvh - 80px);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
`;

export const StyledCard = styled.div`
	max-width: 700px;
	width: 100%;
	padding: 40px;
	box-shadow:
		0 20px 25px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
	border: 1px solid #e2e8f0;
	border-radius: 16px;
	background-color: #ffffff;
`;

export const HeroSection = styled.div`
	text-align: center;
	margin-bottom: 32px;
`;

export const GradientTitle = styled.div`
	margin-bottom: 12px;

	h1 {
		background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		text-align: center;
	}
`;

export const HeroDescription = styled.div`
	color: #64748b;
	max-width: 500px;
	margin: 0 auto;
`;

export const QuestionTitle = styled.div`
	text-align: center;
	margin-bottom: 24px;
	color: #1e293b;
`;

export const ButtonGrid = styled.div`
	display: grid;
	gap: 16px;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
`;

export const HelpBox = styled.div`
	margin-top: 24px;
	padding: 16px;
	background: #f8fafc;
	border-radius: 12px;
	border: 1px solid #e2e8f0;
`;

export const HelpText = styled.div`
	color: #64748b;
	text-align: center;

	p {
		margin: 0;
	}
`;
